// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-question-mark.js';

import { paths } from '../generated/circle-question-mark';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-question-mark', Original, paths);
